import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const USERS_EVENT_NAMES = {
  ADD_USER_SUCCESS: 'admin_added_user_successfully',
  EDIT_USER_SUCCESS: 'admin_edited_user_successfully',
};

export const trackAddUserSuccess = () => {
  gspx.trackEvent({
    name: USERS_EVENT_NAMES.ADD_USER_SUCCESS,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: 'Admin added a new user successfully',
      Category: 'Admin',
      'Launched date': new Date(),
    },
  });
};

export const trackEditUserSuccess = () => {
  gspx.trackEvent({
    name: USERS_EVENT_NAMES.EDIT_USER_SUCCESS,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: 'Admin edited a user successfully',
      Category: 'Admin',
      'Launched date': new Date(),
    },
  });
};
